

export default function Info({ type, title, filename, year }) {
    return <div className="info-box">
      <h2>{title} <>&ndash;</> {year}</h2>
    </div>
  }